<template>
  <section>
    <Feature :title="$t('QUOTATION_DATA_DETAIL')" :iconClass="'fa-check-square'">
      <FormRow :fieldNameArr="[serachDetailTpye]">
        <Input v-model="routerValue" slot="a" disabled />
      </FormRow>
      <FormRow v-if="!isGroupType && selectAllAble" :fieldNameArr="[$t('SELECT_ALL'), '']">
        <RadioGroup v-model="selectAllType" @on-change="changeSelectAll" slot="a">
          <Radio label="DELETE">{{ $t("DELETE") }}</Radio>
          <Radio label="APPROVE">{{ $t("APPROVE") }}</Radio>
          <Radio label="REJECT">{{ $t("REJECT") }}</Radio>
        </RadioGroup>
        <Button type="info" @click="cleanSelect" slot="b">{{ $t('CLEAR_SELECT') }}</Button>
      </FormRow>
      <FormRow v-if="isGroupType && selectAllAble" :fieldNameArr="[$t('SELECT_ALL'), '']">
        <RadioGroup v-model="selectAllType" @on-change="changeSelectAll" slot="a">
          <Radio label="UNGROUP">{{ $t("UNGROUP") }}</Radio>
          <Radio label="APPROVE">{{ $t("APPROVE") }}</Radio>
        </RadioGroup>
        <Button type="info" @click="cleanSelect" slot="b">{{ $t('CLEAR_SELECT') }}</Button>
      </FormRow>
      <TablePage :tableWidth="windowWidth" :columnsList="quotationColumnList" :resultList="quotationList"
        :tableMaxHeight="800"></TablePage>
    </Feature>
    <ButtonRow v-if="!isGroupType">
      <Button type="primary" @click="Submit" slot="1">{{ $t('SUBMIT') }}</Button>
      <Button type="info" @click="Back" slot="2">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <ButtonRow v-if="isGroupType">
      <Button type="primary" @click="UnGroup" slot="1">{{ $t('UNGROUP') }}</Button>
      <Button type="primary" @click="GroupApprove" slot="2">{{ $t('APPROVE') }}</Button>
      <Button type="info" @click="Back" slot="3">{{ $t('BACK') }}</Button>
    </ButtonRow>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logModel"
      :title="$t('PROCESS_LOG')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <TablePage :columnsList="quotationLogColumnList" :resultList="quotationLogList" :tableMaxHeight="800"></TablePage>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="plmFileModel"
      :title="$t('PLM_FILES')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <PLMDocument :plmQuotationDocuments="quotationDocuments" :quotationUuid="quotationUuid"></PLMDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="supplierQuotationFilesModel" :title="$t('QUOTATION_FILE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <FileDocument :attachments="supplierQuotationFiles"></FileDocument>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="scalePricesModel" :title="$t('SCALE_PRICE')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="scalePriceColumnList" :data="scalePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="abnormalsModel"
      :title="$t('ABNORMAL')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="abnormalColumnList" :data="abnormals" max-height="800"></Table>
      </div>
    </Modal>
    <Modal
      v-model="commentsModal"
      :title="$t('COMMENTS')"
      :draggable="true"
      :sticky="true"
      :reset-drag-position="true"
      :ok-text="$t('SAVE')"
      :width="900"
      :z-index="modalSize" 
      @on-ok="confirmComments"
    >
      <froala :config="FloraEditorConfig" v-model="comments"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="remarkModel"
      :title="$t('REMARK')" @on-ok="confirmRemark">
      <froala :config="FloraEditorConfig" v-model="remark"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="referencePriceModel" :title="$t('REFERENCE_PRICE_DATA')">
      <div style="max-height:550px; overflow-y:auto; overflow-x:hidden;">
        <Table :columns="referencePriceColumnList" :data="referencePrices" max-height="800"></Table>
      </div>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="cpcToSupervisorAttachmentsModel" :title="$t('APPROVE') + ' ' + $t('REFERENCE_FILE')">
      <FormRow
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadCpcToSupervisorAttachments">{{
          $t('CLICK_UPLOAD') }}</Button>
      </FormRow>
      <FormRow v-if="cpcToSupervisorAttachmentsExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToSupervisorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download"
              @click="downloadCpcToSupervisorAttachment(row)"></Button>
            <Button type="error" shape="circle" icon="md-close-circle"
              @click="deleteCpcToSupervisorDocument(row)"></Button>
          </template>
        </Table>
      </FormRow>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="cpcToVendorAttachmentsModel" :title="$t('REJECT') + ' ' + $t('REFERENCE_FILE')">
      <FormRow
        :fieldNameArr="['*' + $t('QUOTATION_FILE_UPLOAD') + '(' + $t('FILE_SIZE_LESS_THAN_5MB') + ')', file == null ? '' : file.name]">
        <Upload slot="a" :before-upload="handleUpload" action="*">
          <Button icon="ios-cloud-upload">{{ $t('UPLOAD') }}</Button>
        </Upload>
        <Button type="primary" v-show="file !== null" slot="b" @click="uploadCpcToVendorAttachments">{{ $t('CLICK_UPLOAD')
        }}</Button>
      </FormRow>
      <FormRow v-if="cpcToVendorAttachmentsExited" :fieldNameArr="['']">
        <Table width="600" border :columns="fileSchemaList" :data="cpcToVendorAttachments" slot="a">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" shape="circle" icon="md-download" @click="downloadCpcToVendorAttachment(row)"></Button>
            <Button type="error" shape="circle" icon="md-close-circle" @click="deleteCpcToVendorAttachment(row)"></Button>
          </template>
        </Table>
      </FormRow>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="flowCommentModel" :title="$t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="flowComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900" v-model="logCommentModel"
      :title="$t('HISTORY') + ' ' + $t('COMMENTS')">
      <froala :config="FloraEditorConfig" v-model="logComment"></froala>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="metalAttributeModel" :title="$t('METAL_CASE_ATTRIBUTES')">
      <MetalAttributes :metalQuotation="metalQuotation" :referencePrice="referencePrice" :priceList="priceList">
      </MetalAttributes>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="plasticAttributeModel" :title="$t('PLASTIC_CASE_ATTRIBUTES')">
      <PlasticAttributes :plasticQuotation="plasticQuotation" :referencePrice="referencePrice" :priceList="priceList">
      </PlasticAttributes>
    </Modal>
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="1300"
      v-model="pwbAttributeModel" :title="$t('PWB_CASE_ATTRIBUTES')">
      <PwbAttributes :pwbQuotation="pwbQuotation" :priceList="priceList"></PwbAttributes>
    </Modal>
    <!-- Table Info Record -->
    <Modal :z-index="modalSize" :reset-drag-position="true" sticky :draggable="true" width="900"
      v-model="tableInfoRecordModel" :title="$t('INFO_RECORD')" @on-ok="confirmTableInfoRecord">
      <InfoRecordMaintain v-if="tableInfoRecordModel" :quotation="tableCurrItem.quotationDetailInfoRecordDto" :materialTypeList="materialTypeList"></InfoRecordMaintain>
    </Modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex"
import { mapActions } from "vuex"
import { AlertInfo } from "@/util/alert"
import PLMDocument from '../../components/PLMDocument.vue'
import FileDocument from '../../components/FileDocument.vue'
import { Translate, FloraEditorConfig } from "@/util/common"
import { FileSchemaList } from "@/util/tableTitle"
import moment from "moment"
import MetalAttributes from "@/views/quotation/MetalAttributes"
import PlasticAttributes from "@/views/quotation/PlasticAttributes"
import PwbAttributes from "@/views/quotation/PwbAttributes"
import InfoRecordMaintain from "@/views/quotation/InfoRecordMaintain"


export default {
  name: "CpcDetailMaintain",
  components: {
    PLMDocument,
    FileDocument,
    MetalAttributes,
    PlasticAttributes,
    PwbAttributes,
    InfoRecordMaintain
  },
  data() {
    return {
      FloraEditorConfig: FloraEditorConfig(""),
      actionType: '',
      selectAllType: '',
      tableCurrItem: {},
      materialTypeList: [],
      tableInfoRecordModel: false,
      serachDetailTpye: '',
      routerValue: '',
      statusList: '',
      isFormNoType: false,
      isPartNoType: false,
      isVendorNameType: false,
      isGroupType: false,
      logModel: false,
      plmFileModel: false,
      supplierQuotationFilesModel: false,
      scalePricesModel: false,
      abnormalsModel: false,
      commentsModal: false,
      remarkModel: false,
      referencePriceModel: false,
      cpcToSupervisorAttachmentsModel: false,
      cpcToVendorAttachmentsModel: false,
      flowCommentModel: false,
      logComment: '',
      logCommentModel: false,
      quotationDocuments: [],
      quotationUuid: '',
      quotationLogList: [],
      supplierQuotationFiles: [],
      cpcToSupervisorAttachments: [],
      cpcToVendorAttachments: [],
      scalePrices: [],
      abnormals: [],
      comments: '',
      remark: '',
      defaultValidTo: '',
      flowComment: '',
      file: null,
      fileSchemaList: FileSchemaList(this),
      metalAttributeModel: false,
      metalQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        rawMaterialType: {
          partNo: '',
          partNoDesc: ''
        },
        rmVendor: {
          vendorCode: ''
        },
        coilCenter: {
          vendorCode: ''
        },
        rmPrice: '',
        rmPriceDate: '',
        rmCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      plasticAttributeModel: false,
      plasticQuotation: {
        length: '',
        width: '',
        height: '',
        weight: '',
        model: '',
        resinType: {
          type: ''
        },
        resinVendor: {
          vendorCode: ''
        },
        resinNo: {
          partNo: '',
          partNoDesc: ''
        },
        distributor: {
          vendorCode: ''
        },
        resinColor: '',
        colorNo: '',
        rmPrice: '',
        rmPriceDate: '',
        dyeCost: '',
        cavity: '',
        tannage: '',
        hourlyRate: '',
        cycleTime: '',
        rmCost: '',
        injectingCost: '',
        processingCost: '',
        treatmentCost: '',
        accessoriesCost: '',
        others: '',
        rmRatio: '',
        totalCost: '',
        supplierRemark: ''
      },
      pwbAttributeModel: false,
      pwbQuotation: {
        deltaExchangeRate: "",
        cpcExchangeRate: "",
        rfqBase: "",
        cclLaminateType: "",
        layer: "",
        pcbThickness: "",
        internalCoreThickness: "",
        tg: "",
        externalCopperThickness: "",
        internalCopperThickness: "",
        mainSourceCclSupplier: {
          vendorCode: ""
        },
        mainSourceCclShare: 0,
        mainCoreUlNumber: {
          partNoDesc: ""
        },
        mainCoreUP: "",
        secondSourceCclSupplier: {
          vendorCode: ""
        },
        secondCoreUlNumber: {
          partNoDesc: ""
        },
        secondCoreUP: "",
        pcbPrice: "",
        panelLength: "",
        panelWidth: "",
        pnLength: "",
        pnWidth: "",
        area: "",
        pnArea: "",
        supplierSheetSize: "",
        deltaSheetSize: "",
        panelSheet: "",
        pnInSheet: "",
        pnInPanel: "",
        pnUtilization: "",
        panelUtilization: "",
        combineRatio: "",
        numberOfDrill: "",
        slotLength: "",
        goldArea: "",
        materialCost: "",
        surfaceFinishCost: "",
        processCost: "",
        specialCostDown: "",
        deltaPnPriceUsd: "",
        deltaPnPrice: "",
        supplierRemark: ""
      },
      referencePrice: '',
      priceList: [],
      referencePriceColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('MATERIAL');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          key: "materialNumber",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('AGENT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "agent",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('AGENT_NAME');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          key: "agentName",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('INFO_CATEGORY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "purchInfoRecordCategory",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_FROM');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "validFromDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VALID_TO');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "validToDate",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT_CODE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "currency",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "unitPirce",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('USD_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "usdPrice",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UOM');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "conditionUnit",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('%');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "percentage",
        },
      ],
      referencePrices: [],
      scalePriceColumnList: [
        {
          title: 'Item',
          key: 'item',
          align: 'center',
          width: 80
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('QUANTITY')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scaleQuantity',
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('SCALE') + '<br>' + this.$t('PRICE')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          key: 'scalePrice'
        }
      ],
      abnormalColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'item',
          width: 100,
          align: "center",
          render: (h, params) => {
            let status = "";
            if (params.row["status"].statusViewEnum == "CANCEL") {
              status = "Cancel"
            } else if (params.row["status"].statusViewEnum == "WAITING_SUPPLIER" || params.row["status"].statusViewEnum == "SUPPLIER") {
              status = "Reject"
            }
            return h("span", {}, status)
          }
        },
        {
          title: "Form NO.",
          align: 'center',
          width: 140,
          key: "formNo"
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('RFQ_TYPE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h("span", {}, params.row["rfqType"].description)
          }
        },
        {
          renderHeader: (h, params) => {
            let text = this.$t('DELTA_PN') + '<br>' + this.$t('PN_DESCRIPTION')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          render: (h, params) => {
            let deltaPart = params.row.deltaPart != undefined ? params.row.deltaPart : ""
            let deltaPartDesc = params.row.deltaPartDesc != undefined ? params.row.deltaPartDesc : ""
            let text = deltaPart + "<br>" + deltaPartDesc
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('VENDOR_CODE') + "<br>" + this.$t('OA_VENDOR_NAME')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 140,
          render: (h, params) => {
            let vendorCode = params.row.vendorCode != undefined ? params.row.vendorCode : ""
            let vendorName = params.row.vendorName != undefined ? params.row.vendorName : ""
            let text = vendorCode + "<br>" + vendorName
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CURRENCY');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "currency",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('UNIT_PRICE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 80,
          key: "price",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLANT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          align: 'center',
          width: 100,
          key: "plant",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('REFERENCE_PRICE_DATA');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryReferencePrice(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.referencePrices = data
                    this.referencePriceModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PLM') + '<br>' + this.$t('FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "md-download",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryPlmDocuments(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.quotationDocuments = data
                    this.plmFileModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('QUOTATION') + '<br>' + this.$t('FILES')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: params.row["supplierQuotationFiles"] && params.row["supplierQuotationFiles"].filter(attachment => !attachment.deleted).length > 0 ? "ios-cloud-download" : "",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.supplierQuotationFiles = []
                  this.supplierQuotationFiles = params.row.supplierQuotationFiles.filter(attachment => !attachment.deleted)
                  this.supplierQuotationFilesModel = true
                },
              },
            })
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('LOG')
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28,
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  this.toggleLoading(true)
                  this.$queryQuotationLog(this, params.row.uuid).then(data => {
                    this.toggleLoading(false)
                    this.quotationUuid = params.row.uuid
                    this.quotationLogList = data
                    this.logModel = true
                  }).catch((error) => {
                    AlertInfo(this, this.$t('COMMON_MESSAGE_SYSTEM_ERROR')).then(() => {
                    })
                  })
                },
              },
            })
          }
        },
      ],
      quotationLogColumnList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t('ROLE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "quotationRole",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('STATUS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowStatus",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('GROUP_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "groupAccount",
          width: 180,
          align: "center",
          render: (h, params) => {
            return h("span", {}, params.row["groupAccount"].companyName)
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('ACTION');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "flowAction",
          width: 150,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('COMMENTS');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          width: 150,
          align: "center",
          render: (h, params) => {
            if (params.row.flowComment) {
              return h("Icon", {
                props: {
                  type: "ios-paper",
                  size: 28,
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.flowComment = params.row.flowComment
                    this.flowCommentModel = true
                  },
                },
              })
            } else {
              return h("span", {}, "")
            }
          }
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('CREATE_DATE');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "created",
          width: 180,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t('PERSON_ACCOUNT');
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: "personEmail",
          width: 200,
          align: "center",
        },
      ],
      quotationList: []
    }
  },
  created() {
    const vueInstance = this;
    vueInstance.defaultValidTo = getDefaultValidTo();
    // call info record material type option
    vueInstance.$quotationHttp
      .get("/quotation/material-type")
      .then(response => {
        if (response.data) {
          vueInstance.materialTypeList = response.data;
        }
    });
    search(this)
  },
  methods: {
    ...mapGetters(["getUserProfile", "getLanguage", "getCpcQuotationId", "getCpcDeltaPnSingle", "getCpcOaCode", "getCpcGroupId", "getCpcFormNo"
      , "getCpcRfqType", "getCpcStatus", "getCpcDeltaPn", "getCpcVendorPn", "getCpcVendorCode", "getCpcFromRfqDate", "getCpcToRfqDate",
      "getCpcStatusEnum", "getCpcGroupUuid", "getModalSize", "getWindowsWidth"]),
    ...mapActions(["toggleLoading"]),
    changeSelectAll() {
      this.metalAttributeModel = false
      this.plasticAttributeModel = false
      this.pwbAttributeModel = false
      this.quotationList.forEach(quotation => {
        let index = this.quotationList.findIndex(temp => temp.uuid == quotation.uuid)
        this.$set(this.quotationList[index], 'action', this.selectAllType);
      })
    },
    cleanSelect() {
      this.metalAttributeModel = false
      this.plasticAttributeModel = false
      this.pwbAttributeModel = false
      this.selectAllType = ""
      this.quotationList.forEach(quotation => {
        let index = this.quotationList.findIndex(temp => temp.uuid == quotation.uuid)
        this.$set(this.quotationList[index], 'action', undefined);
      })
    },
    UnGroup() {
      let vueInstance = this
      let promiseList = []
      vueInstance.toggleLoading(true)
      vueInstance.quotationList.forEach(quotation => {
        if (quotation.action && quotation.action === "UNGROUP") {
          promiseList.push(unGroup(quotation, vueInstance))
        }
      })
      if (promiseList.length > 0) {
        Promise.all(promiseList).then(responseList => {
          vueInstance.toggleLoading(false)
          let msg = ""
          responseList.forEach(response => {
            if (response.content[0].status.includes("Un-Group")) {
              vueInstance.quotationList.splice(vueInstance.quotationList.findIndex(quotation => quotation.formNo == response.content[0].id), 1)
              msg = msg.concat("Form No: ", response.content[0].id, ", ", response.content[0].status, "<br>")
            }
          })
          vueInstance.$Swal.fire({
            icon: "info",
            title: vueInstance.$t("COMMON_MESSAGE_INFO"),
            html: msg,
          })
          if (vueInstance.quotationList.length == 0) {
            vueInstance.$router.push({ name: 'CPC_MAINTAIN' })
          } else if (vueInstance.quotationList.length == 1) {
            unGroup(vueInstance.quotationList[0], vueInstance)
            vueInstance.$router.push({ name: 'CPC_MAINTAIN' })
          }
        })
      } else {
        vueInstance.toggleLoading(false)
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: "No Select Un-Group Data",
        })
      }
    },
    GroupApprove() {
      const vueInstance = this;
      let canApprove = vueInstance.quotationList
        .every(quotation => quotation.action === "APPROVE");
      if (canApprove === false) {
        AlertInfo(vueInstance, vueInstance.$t("MUST_APPROVE_ALL"))
          .then(() => {});
        return;
      }
      const errorMessageArray = [];
      vueInstance.quotationList.forEach(quotation => {
        if (!quotation.comments) {
          errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("COMMENTS"));
        }
        if (!quotation.validFrom) {
          errorMessageArray.push(quotation.formNo + ": [" + vueInstance.$t("VALID_FROM") + "]" + vueInstance.$t("IS_REQUIRED"));
        }
        if (!quotation.validTo) {
          errorMessageArray.push(quotation.formNo + ": [" + vueInstance.$t("VALID_TO") + "]" + vueInstance.$t("IS_REQUIRED"));
        }
        if (quotation.validFrom && quotation.validTo) {
          const validFrom = new Date(quotation.validFrom);
          const validTo = new Date(quotation.validTo);
          if (validTo < validFrom) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_DATE_INVALID"));
          }
          const dayDiff = (validTo - validFrom) / (1000 * 60 * 60 * 24);
          if (dayDiff > 548) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_DATE_PERIOD_INVALID"));
          }
          const yearDiff = validTo.getFullYear() - validFrom.getFullYear();
          if (yearDiff >= 2) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_YEAR_PERIOD_INVALID"));
          }
        }
      });
      if (errorMessageArray.length > 0) {
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: errorMessageArray.join("<br>")
        });
        return;
      }
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .patch("/cpc/group/checkHighPrice", {
          quotationList: vueInstance.quotationList.map(quotation => {
            return {
              formNo: quotation.formNo,
              validFrom: quotation.validFrom,
              validTo: quotation.validTo
            };
          })
        })
        .then(response => {
          response.data.quotationList.forEach(quotationRequest => {
            let quotation = vueInstance.quotationList.find(q => q.formNo === quotationRequest.formNo);
            vueInstance.$set(quotation, "highPrice", quotationRequest.highPrice);
            vueInstance.$set(quotation, "quotationHighPrice", quotationRequest.quotationHighPrice);
          });
          if (vueInstance.quotationList.some(quotation => quotation.highPrice === true) === true) {
            vueInstance.$Swal
              .fire({
                icon: "info",
                title: vueInstance.$t("COMMON_MESSAGE_INFO"),
                text: vueInstance.$t("HIGH_PRICE_COMFIRM"),
                showCancelButton: true,
                confirmButtonColor: "#19be6b",
                cancelButtonColor: "#d33",
                confirmButtonText: vueInstance.$t("COMMON_TEXT_CONFIRM"),
                cancelButtonText: vueInstance.$t("COMMON_TEXT_CANCEL")
              })
              .then(result => {
                if (result.isConfirmed) {
                  vueInstance.toggleLoading(true);
                  vueInstance.$quotationHttp
                    .post("/cpc/group/approve", {
                      groupId: vueInstance.routerValue,
                      quotationRequestList: vueInstance.quotationList.map(quotation => {
                        return {
                          formNo: quotation.formNo,
                          comments: quotation.comments,
                          targetPrice: quotation.targetPrice,
                          remark: quotation.remark,
                          validFrom: quotation.validFrom,
                          validTo: quotation.validTo,
                          cpcToSupervisorAttachments: quotation.cpcToSupervisorAttachments,
                          materialType: quotation.quotationDetailInfoRecordDto.materialType?.code,
                          conditionValueForFRA1: quotation.quotationDetailInfoRecordDto.conditionMap.FRA1,
                          conditionValueForZOA1: quotation.quotationDetailInfoRecordDto.conditionMap.ZOA1,
                          conditionValueForZII1: quotation.quotationDetailInfoRecordDto.conditionMap.ZII1,
                          transportDays: quotation.quotationDetailInfoRecordDto.transportDays,
                          planDeliveryTime: quotation.quotationDetailInfoRecordDto.planDelTime,
                          minimumOrderQty: quotation.quotationDetailInfoRecordDto.minOrderQty
                        };
                      })
                    })
                    .then(response => {
                      vueInstance.$Swal.fire({
                        icon: "info",
                        title: vueInstance.$t("COMMON_MESSAGE_INFO"),
                        html: "Group Key: " + vueInstance.routerValue + ", " + vueInstance.$t("COMMON_MESSAGE_APPROVE_SUCCESS")
                      })
                      .then(() => {
                        vueInstance.$router.push({
                          name: "CPC_MAINTAIN"
                        });
                      });
                    })
                    .catch(error => {
                      console.error(error);
                      AlertError(vueInstance, error, true)
                        .then(() => {});
                    });
                }
              });
          } else {
            vueInstance.$quotationHttp
              .post("/cpc/group/approve", {
                groupId: vueInstance.routerValue,
                quotationRequestList: vueInstance.quotationList.map(quotation => {
                  return {
                    formNo: quotation.formNo,
                    comments: quotation.comments,
                    targetPrice: quotation.targetPrice,
                    remark: quotation.remark,
                    validFrom: quotation.validFrom,
                    validTo: quotation.validTo,
                    cpcToSupervisorAttachments: quotation.cpcToSupervisorAttachments,
                    materialType: quotation.quotationDetailInfoRecordDto.materialType?.code,
                    conditionValueForFRA1: quotation.quotationDetailInfoRecordDto.conditionMap.FRA1,
                    conditionValueForZOA1: quotation.quotationDetailInfoRecordDto.conditionMap.ZOA1,
                    conditionValueForZII1: quotation.quotationDetailInfoRecordDto.conditionMap.ZII1,
                    transportDays: quotation.quotationDetailInfoRecordDto.transportDays,
                    planDeliveryTime: quotation.quotationDetailInfoRecordDto.planDelTime,
                    minimumOrderQty: quotation.quotationDetailInfoRecordDto.minOrderQty
                  };
                })
              })
              .then(response => {
                vueInstance.$Swal.fire({
                  icon: "info",
                  title: vueInstance.$t("COMMON_MESSAGE_INFO"),
                  html: "Group Key: " + vueInstance.routerValue + ", " + vueInstance.$t("COMMON_MESSAGE_APPROVE_SUCCESS")
                })
                .then(() => {
                  vueInstance.$router.push({
                    name: "CPC_MAINTAIN"
                  });
                });
              })
              .catch(error => {
                console.error(error);
                AlertError(vueInstance, error, true)
                  .then(() => {});
              });
          }
        })
        .catch(error => {
          console.error(error);
          AlertError(vueInstance, error, true)
            then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    Submit() {
      const vueInstance = this;
      let approveList = [];
      let rejectList = [];
      let deleteList = [];
      vueInstance.quotationList.forEach(quotation => {
        let action = quotation.action;
        if (action === undefined) {
          return;
        }
        switch (action) {
          case "APPROVE":
            approveList.push({
              uuid: quotation.uuid,
              formNo: quotation.formNo,
              comments: quotation.comments,
              targetPrice: quotation.targetPrice,
              validFrom: quotation.validFrom,
              validTo: quotation.validTo,
              cpcToSupervisorAttachments: quotation.cpcToSupervisorAttachments,
              remark: quotation.remark,
              materialType: quotation.quotationDetailInfoRecordDto.materialType?.code,
              conditionValueForFRA1: quotation.quotationDetailInfoRecordDto.conditionMap.FRA1,
              conditionValueForZOA1: quotation.quotationDetailInfoRecordDto.conditionMap.ZOA1,
              conditionValueForZII1: quotation.quotationDetailInfoRecordDto.conditionMap.ZII1,
              transportDays: quotation.quotationDetailInfoRecordDto.transportDays,
              planDeliveryTime: quotation.quotationDetailInfoRecordDto.planDelTime,
              minimumOrderQty: quotation.quotationDetailInfoRecordDto.minOrderQty
            })
            break;
          case "REJECT":
            rejectList.push({
              formNo: quotation.formNo,
              comments: quotation.comments,
              targetPrice: quotation.targetPrice,
              cpcToVendorFileVaultList: quotation.cpcToVendorAttachments
            })
            break;
          case "DELETE":
            deleteList.push({
              formNo: quotation.formNo,
              comments: quotation.comments
            })
            break;
        }
      });
      if (approveList.length === 0 && rejectList.length === 0 && deleteList.length === 0) {
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: "No Select Submit Data",
        });
        return;
      }
      let errorMessageArray = [];
      approveList.forEach(quotation => {
        if (!quotation.comments) {
          errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("COMMENTS"));
        }
        if (!quotation.validFrom) {
          errorMessageArray.push(quotation.formNo + ": [" + vueInstance.$t("VALID_FROM") + "]" + vueInstance.$t("IS_REQUIRED"));
        }
        if (!quotation.validTo) {
          errorMessageArray.push(quotation.formNo + ": [" + vueInstance.$t("VALID_TO") + "]" + vueInstance.$t("IS_REQUIRED"));
        }
        if (quotation.validFrom && quotation.validTo) {
          const validFrom = new Date(quotation.validFrom);
          const validTo = new Date(quotation.validTo);
          if (validTo < validFrom) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_DATE_INVALID"));
          }
          const dayDiff = (validTo - validFrom) / (1000 * 60 * 60 * 24);
          if (dayDiff > 548) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_DATE_PERIOD_INVALID"));
          }
          const yearDiff = validTo.getFullYear() - validFrom.getFullYear();
          if (yearDiff >= 2) {
            errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("VALID_FROM_VALID_TO_YEAR_PERIOD_INVALID"));
          }
        }
      });
      rejectList.forEach(quotation => {
        if (!quotation.comments) {
          errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("COMMENTS"));
        }
      });
      deleteList.forEach(quotation => {
        if (!quotation.comments) {
          errorMessageArray.push(quotation.formNo + ": " + vueInstance.$t("PLEASE_KEY_IN") + vueInstance.$t("COMMENTS"));
        }
      });
      if (errorMessageArray.length > 0) {
        vueInstance.$Swal.fire({
          icon: "info",
          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
          html: errorMessageArray.join("<br>")
        });
        return;
      }
      let promiseArray = [];
      if (approveList.length > 0) {
        promiseArray.push(vueInstance.$quotationHttp
          .patch("/cpc/group/checkHighPrice", {
            quotationList: approveList.map(quotation => {
              return {
                formNo: quotation.formNo,
                validFrom: quotation.validFrom,
                validTo: quotation.validTo
              };
            })
          }));
      }
      if (rejectList.length > 0) {
        promiseArray.push(vueInstance.$quotationHttp
          .post("/cpc/reject", {
            quotationRequestList: rejectList
          }));
      }
      if (deleteList.length > 0) {
        promiseArray.push(vueInstance.$quotationHttp
          .post("/cpc/delete", {
            quotationRequestList: deleteList
          }));
      }
      vueInstance.toggleLoading(true);
      Promise.all(promiseArray)
        .then(responseList => {
          if (approveList.length == 0) {
            return;
          }
          let checkHighPriceResponse = responseList[0];
          if (checkHighPriceResponse !== undefined) {
            let quotationRequestList = checkHighPriceResponse.data.quotationList;
            quotationRequestList.forEach(qr => {
              let quotation = vueInstance.quotationList.find(q => q.formNo === qr.formNo);
              vueInstance.$set(quotation, "highPrice", qr.highPrice);
              vueInstance.$set(quotation, "quotationHighPrice", qr.quotationHighPrice);
            });
            let quotationListForHighPrice = vueInstance.quotationList.filter(q => q.highPrice);
            if (quotationListForHighPrice.length === 0) {
              vueInstance.$quotationHttp
                .post("/cpc/approve", {
                  quotationRequestList: approveList
                })
                .then(response => {
                  vueInstance.$Swal.fire({
                    icon: "info",
                    title: vueInstance.$t("COMMON_MESSAGE_INFO"),
                    html: vueInstance.$t("COMMON_MESSAGE_APPROVE_SUCCESS")
                  });
                })
                .catch(error => {
                  console.error(error);
                  AlertError(vueInstance, error, true)
                    .then(() => {});
                });
            } else {
              vueInstance.$Swal
                .fire({
                  icon: "info",
                  title: vueInstance.$t("COMMON_MESSAGE_INFO"),
                  text: vueInstance.$t("HIGH_PRICE_COMFIRM"),
                  showCancelButton: true,
                  confirmButtonColor: "#19be6b",
                  cancelButtonColor: "#d33",
                  confirmButtonText: vueInstance.$t("COMMON_TEXT_CONFIRM"),
                  cancelButtonText: vueInstance.$t("COMMON_TEXT_CANCEL")
                })
                .then(result => {
                  if (result.isConfirmed) {
                    vueInstance.toggleLoading(true);
                    vueInstance.$quotationHttp
                      .post("/cpc/approve", {
                        quotationRequestList: approveList
                      })
                      .then(response => {
                        vueInstance.$Swal.fire({
                          icon: "info",
                          title: vueInstance.$t("COMMON_MESSAGE_INFO"),
                          html: vueInstance.$t("COMMON_MESSAGE_APPROVE_SUCCESS")
                        });
                      })
                      .catch(error => {
                        console.error(error);
                        AlertError(vueInstance, error, true)
                          .then(() => {});
                      });
                  }
                });
            }
          }
        })
        .catch(error => {
          console.error(error);
          AlertError(vueInstance, error, true)
            .then(() => {});
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
          vueInstance.$router.push({
            name: "CPC_MAINTAIN"
          });
        });
    },
    Back() {
      this.$router.push({ name: 'CPC_MAINTAIN' })
    },
    confirmComments() {
      const vueInstance = this;
      const formNoList = [];
      const comments = vueInstance.comments;
      vueInstance.quotationList.forEach(temp => {
        if (temp.uuid === vueInstance.quotationUuid || (vueInstance.actionType && vueInstance.actionType === temp.action)) {
          temp.comments = vueInstance.comments;
          formNoList.push(temp.formNo);
        }
      });
      vueInstance.toggleLoading(true);
      vueInstance.$quotationHttp
        .patch("/cpc/batchUpdateComments", { formNoList, comments })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    confirmRemark() {
      this.quotationList.forEach(temp => {
        if (temp.uuid == this.quotationUuid) {
          temp.remark = this.remark
        }
      })
    },
    confirmTableInfoRecord() {
      const vueInstance = this;
      vueInstance.quotationList.forEach(temp => {
        if (temp.uuid == vueInstance.tableCurrItem.uuid) {
          temp.quotationDetailInfoRecordDto  = vueInstance.tableCurrItem.quotationDetailInfoRecordDto ;
        }
      });
      vueInstance.tableCurrItem = {};
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    uploadCpcToSupervisorAttachments() {
      const vueInstance = this;
      const formData = new FormData();
      formData.append("file", vueInstance.file);
      formData.append("description", "quotation CPC to Supervisor attachment");
      vueInstance.toggleLoading(true);
      vueInstance.$fileHttp
        .post(`/attachment/upload-single?description=quotation${vueInstance.quotationUuid}`, formData)
        .then(response => {
          vueInstance.cpcToSupervisorAttachments.push(response.data);
          vueInstance.quotationList.forEach(quotation => {
            if (quotation.uuid === vueInstance.quotationUuid || (vueInstance.actionType && vueInstance.actionType === quotation.action)) {
              if (!quotation.cpcToSupervisorAttachments) {
                quotation.cpcToSupervisorAttachments = [];
              }
              quotation.cpcToSupervisorAttachments.push(response.data);
            }
          });
          vueInstance.file = null;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          vueInstance.toggleLoading(false);
        });
    },
    downloadCpcToSupervisorAttachment(row) {
      this.$downloadAttachment(this, row.id)
    },
    deleteCpcToSupervisorDocument(row) {
      let temp
      this.quotationList.forEach(quotation => {
        if (quotation.uuid == this.quotationUuid) {
          temp = quotation
          quotation.cpcToSupervisorAttachments.forEach(attachment => {
            if (attachment.id == row.id) {
              attachment.deleted = true
            }
          })
        }
      })
      this.cpcToSupervisorAttachments = temp.cpcToSupervisorAttachments.filter(attachment => attachment.deleted != true)
    },
    uploadCpcToVendorAttachments() {
      let fd = new FormData()
      fd.append('file', this.file)
      fd.append('description', "quotaion attachement")
      this.toggleLoading(true)
      this.$fileHttp
        .post("/attachment/upload-single?description=quotation" + this.quotationUuid, fd)
        .then((response) => {
          this.toggleLoading(false)
          this.cpcToVendorAttachments.push(response.data)
          this.quotationList.forEach(quotation => {
            if (quotation.uuid == this.quotationUuid) {
              if (!quotation.cpcToVendorAttachments) {
                quotation.cpcToVendorAttachments = []
              }
              quotation.cpcToVendorAttachments.push(response.data)
            }
          })
          this.file = null
          this.toggleLoading(false)
        })
        .catch(() => { })
    },
    downloadCpcToVendorAttachment(row) {
      this.$downloadAttachment(this, row.id)
    },
    deleteCpcToVendorAttachment(row) {
      let temp
      this.quotationList.forEach(quotation => {
        if (quotation.uuid == this.quotationUuid) {
          temp = quotation
          quotation.cpcToVendorAttachments.forEach(attachment => {
            if (attachment.id == row.id) {
              attachment.deleted = true
            }
          })
        }
      })
      this.cpcToVendorAttachments = temp.cpcToVendorAttachments.filter(attachment => !attachment.deleted)
    }
  },
  computed: {
    quotationColumnList() {
      return [{
        title: this.$t("ACTION"),
        width: 100,
        align: "center",
        render: (h, params) => {
          let result = []
          if (this.$route.name == "CPC_MAINTAIN_DETAIL_GROUP_ID") {
            if (params.row.status.statusViewEnum == "WAITING_BUYER") {
              result.push(h("Radio", {
                style: {
                  display: "inline-block",
                  "font-size": "14px"
                },
                props: {
                  label: "UNGROUP"
                }
              }, this.$t("UNGROUP")),
              h("Radio", {
                style: {
                  display: "inline-block",
                  "font-size": "14px"
                },
                props: {
                  label: "APPROVE"
                }
              }, this.$t("APPROVE")));
            }
          } else if (params.row.status.statusViewEnum == "WAITING_BUYER") {
            result.push(h("Radio", {
              style: {
                display: "inline-block",
                "font-size": "14px"
              },
              props: {
                label: "DELETE"
              }
            }, this.$t("DELETE")),
            h("Radio", {
              style: {
                display: "inline-block",
                "font-size": "14px"
              },
              props: {
                label: "APPROVE"
              }
            }, this.$t("APPROVE")),
            h("Radio", {
              style: {
                display: "inline-block",
                "font-size": "14px"
              },
              props: {
                label: "REJECT"
              }
            }, this.$t("REJECT")));
          } else if (params.row.status.statusViewEnum == "WAITING_SUPPLIER") {
            result.push(h("Radio", {
              style: {
                display: "inline-block",
                "font-size": "14px"
              },
              props: {
                label: "DELETE"
              }
            }, this.$t("DELETE")));
          }
          return h("RadioGroup", {
            props: {
              value: this.quotationList[params.index].action
            },
            on: {
               "on-change": (val) => {
                this.$set(this.quotationList[params.index], 'action', val);
              }
            }
          }, result);
        }
      }, {
        title: this.$t("COMMENTS"),
        width: 90,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "ios-create",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.comments = this.quotationList[params.index].comments ? this.quotationList[params.index].comments : "";
                this.actionType = this.quotationList[params.index].action ? this.quotationList[params.index].action : "";
                this.quotationUuid = params.row.id;
                this.commentsModal = true;
              }
            }
          });
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("HISTORY"),
            h("br"),
            this.$t("COMMENTS")
          ]);
        },
        width: 70,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "ios-paper",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.toggleLoading(true)
                this.$queryQuotationLog(this, params.row.uuid)
                  .then(data => {
                    this.logComment = ""
                    this.quotationUuid = params.row.uuid
                    data.forEach(log => {
                      if (log.quotationRole) {
                        this.logComment = this.logComment + this.$t('ROLE') + ": " + log.quotationRole + ", ";
                      }
                      if (log.quotationRole) {
                        this.logComment = this.logComment + this.$t('STATUS') + ": " + log.flowStatus + ", ";
                      }
                      if (log.groupAccount) {
                        this.logComment = this.logComment + this.$t('GROUP_ACCOUNT') + ": " + log.groupAccount.code + "/" + log.groupAccount.companyName + ", ";
                      }
                      if (log.created) {
                        this.logComment = this.logComment + this.$t('CREATE_DATE') + ": " + log.created + ": <br>";
                      }
                      if (log.flowComment) {
                        this.logComment = this.logComment + log.flowComment;
                      }
                      this.logComment = this.logComment + "<hr style='border:1px dashed #000; height:1px'>";
                    })
                    this.logCommentModel = true
                  })
                  .catch(error => {
                    AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
                      .then(() => {
                        console.error(error);
                      });
                  })
                  .finally(() => {
                    this.toggleLoading(false);
                  });
              }
            }
          });
        }
      }, {
        title: this.$t("RFQ_TYPE"),
        width: 85,
        align: "center",
        render: (h, params) => {
          return h("span", {}, params.row.rfqType.description);
        }
      }, {
        title: this.$t("CATEGORY"),
        width: 60,
        align: "center",
        key: "category"
      }, {
        title: this.$t("INFO_RECORD"),
        width: 60,
        align: "center",
        render: (h, params) => {
          return h("div", {}, [
            h("label", params.row.infoRecordFlag === true ? [
              "Yes",
              h("Icon", {
                props: {
                  type: "md-create",
                  size: 28
                },
                class: "text-delta-blue",
                on: {
                  click: () => {
                    this.tableCurrItem = structuredClone(this.quotationList[params.index]);
                    this.tableInfoRecordModel = true;
                  }
                }
              })
            ] : "No")
          ]);
        }
      }, {
        title: this.$t("HIGH_PRICE"),
        width: 60,
        align: "center",
        render: (h, params) => {
          if (this.quotationList[params.index].highPrice === true) {
            return h("div", [
              h("Icon", {
                props: {
                  type: "ios-warning",
                  size: 28
                },
                class: "text-delta-red"
              }),
              h('div', {}, params.row.quotationHighPrice? params.row.quotationHighPrice.priceDifference + "%" : ''),
              h('div', {}, params.row.quotationHighPrice?.orgCheck ? (params.row.quotationHighPrice.orgCheck === "C" ? "Cross" : "Single") : "null")
            ]);
          }
          return "";
        }
      }, {
        title: this.$t("ABNORMAL"),
        width: 60,
        align: "center",
        render: (h, params) => {
          if (params.row.abnormals === undefined) {
            this.$set(this.quotationList[params.index], "abnormals", []);
            this.$queryAbnormals(this, params.row.uuid)
              .then(data => {
                this.$set(this.quotationList[params.index], "abnormals", data);
              })
              .catch(error => {
                AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
                  .then(() => {
                    console.error(error);
                  });
              });
          }
          return h("Icon", {
            props: {
              type: params.row.abnormals ? (params.row.abnormals.length > 0 ? "ios-warning" : "ios-loading") : "",
              size: 28
            },
            class: "text-delta-red",
            on: {
              click: () => {
                if (params.row.abnormals && params.row.abnormals.length > 0) {
                  this.quotationUuid = params.row.uuid;
                  this.abnormals = params.row.abnormals;
                  this.abnormalsModel = true;
                }
              }
            }
          });
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("DELTA_PN"),
            h("br"),
            this.$t("PN_DESCRIPTION")
          ]);
        },
        width: 100,
        align: "center",
        render: (h, params) => {
          return h("div", {}, [
            params.row.deltaPart !== undefined ? params.row.deltaPart : "",
            h("br"),
            params.row.deltaPartDesc !== undefined ? params.row.deltaPartDesc : ""
          ]);
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("VENDOR_CODE"),
            h("br"),
            this.$t("OA_VENDOR_NAME")
          ]);
        },
        width: 90,
        align: "center",
        render: (h, params) => {
          return h("div", {}, [
            params.row.vendorCode !== undefined ? params.row.vendorCode : "",
            h("br"),
            params.row.vendorName !== undefined ? params.row.vendorName : ""
          ]);
        }
      }, {
        title: this.$t("VENDOR_PN"),
        width: 80,
        align: "center",
        key: "vendorPartNo"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("TARGET"),
            h("br"),
            this.$t("PRICE")
          ]);
        },
        width: 80,
        align: "center",
        render: (h, params) => {
          if (params.row.status.statusViewEnum === "WAITING_BUYER") {
            return h("Input", {
              style: {
                textAlign: "center"
              },
              props: {
                type: "text",
                value: params.row.targetPrice
              },
              on: {
                "on-change": (event) => {
                  this.quotationList[params.index].targetPrice = event.target.value;
                }
              }
            });
          }
          return h("span", {}, params.row.targetPrice);
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("UNIT_PRICE"),
            h("br"),
            this.$t("CURRENCY")
          ]);
        },
        width: 90,
        align: "center",
        render: (h, params) => {
          if (params.row.abnormals && params.row.abnormals.quoteRedAlert || params.row.quoteRedAlert) {
            return h("div", [
              h("Button", {
                props: {
                  type: "error",
                  shape: "circle",
                  size: "small"
                },
                style: {
                  width: "80%"
                }
              }, params.row.price),
              h("span", {}, "/" + params.row.currency)
            ]);
          } else {
            return h("div", {}, [
              params.row.price !== undefined ? params.row.price : "",
              "/",
              params.row.currency !== undefined ? params.row.currency : ""
            ]);
          }
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("AVERAGE_PURCHASE_PRICE"),
            h("br"),
            this.$t("CURRENCY")
          ]);
        },
        width: 90,
        align: "center",
        render: (h, params) => {
          return h("div", {}, [
            params.row.averagePrice !== undefined ? params.row.averagePrice : "",
            "/",
            params.row.averagePriceCurrency !== undefined ? params.row.averagePriceCurrency : ""
          ]);
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("BASIC"),
            h("br"),
            this.$t("UNIT")
          ]);
        },
        width: 50,
        align: "center",
        key: "unit"
      }, {
        title: this.$t("PLANT_CODE"),
        width: 50,
        align: "center",
        key: "plant"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("PLM"),
            h("br"),
            this.$t("FILES")
          ]);
        },
        width: 60,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "md-download",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.toggleLoading(true);
                this.$queryPlmDocuments(this, params.row.uuid)
                  .then(data => {
                    this.quotationUuid = params.row.uuid;
                    this.quotationDocuments = data;
                    this.plmFileModel = true;
                  })
                  .catch(error => {
                    AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
                      .then(() => {
                        console.error(error);
                      });
                  })
                  .finally(() => {
                    this.toggleLoading(false);
                  });
              }
            }
          });
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("QUOTATION"),
            h("br"),
            this.$t("FILES")
          ]);
        },
        width: 60,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: params.row["supplierQuotationFiles"] && params.row["supplierQuotationFiles"].filter(attachment => !attachment.deleted).length > 0 ? "ios-cloud-download" : "",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.supplierQuotationFiles = [];
                this.supplierQuotationFiles = params.row.supplierQuotationFiles.filter(attachment => !attachment.deleted);
                this.supplierQuotationFilesModel = true;
              }
            }
          });
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("SCALE"),
            h("br"),
            this.$t("PRICE")
          ]);
        },
        width: 60,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: params.row["scalePrices"] && params.row["scalePrices"].length > 0 ? "md-reorder" : "",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.scalePrices = params.row.scalePrices;
                this.scalePricesModel = true;
              }
            }
          });
        }
      }, {
        title: this.$t("REFERENCE_PRICE_DATA"),
        width: 65,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "ios-paper",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.toggleLoading(true);
                this.$queryReferencePrice(this, params.row.uuid)
                  .then(data => {
                    this.quotationUuid = params.row.uuid;
                    this.referencePrices = data;
                    this.referencePriceModel = true;
                  })
                  .catch(error => {
                    AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
                      .then(() => {
                        console.error(error);
                      });
                  })
                  .finally(() => {
                    this.toggleLoading(false);
                  });
              }
            }
          });
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("GROUP"),
            h("br"),
            this.$t("COMPARE"),
            "(%)"
          ]);
        },
        width: 65,
        align: "center",
        key: "comparePrice"
      }, {
        title: this.$t("RAW_MATERIAL_TYPE"),
        width: 80,
        align: "center",
        key: "rawMaterialType"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("RAW_MATERIAL"),
            h("br"),
            this.$t("PRICE_UNIT")
          ]);
        },
        width: 80,
        align: "center",
        render: (h, params) => {
          return h("div", {}, [
            params.row.rawMaterialPrice !== undefined ? params.row.rawMaterialPrice : "",
            "/",
            params.row.rawMaterialUnit !== undefined ? params.row.rawMaterialUnit : ""
          ]);
        }
      }, {
        title: this.$t("RM_REMARK"),
        width: 50,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "ios-create",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.remark = this.quotationList[params.index].remark;
                this.quotationUuid = params.row.id;
                this.remarkModel = true;
              }
            }
          });
        }
      }, {
        title: this.$t("YMGR_REMARK"),
        width: 80,
        align: "center",
        key: "ymgrRemark"
      }, {
        title: this.$t("LOG"),
        width: 50,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "ios-paper",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.toggleLoading(true);
                this.$queryQuotationLog(this, params.row.uuid)
                  .then(data => {
                    this.quotationUuid = params.row.uuid;
                    this.quotationLogList = data;
                    this.logModel = true;
                  })
                  .catch(error => {
                    AlertInfo(this, this.$t("COMMON_MESSAGE_SYSTEM_ERROR"))
                      .then(() => {
                        console.error(error);
                      });
                  })
                  .finally(() => {
                    this.toggleLoading(false);
                  });
              }
            }
          });
        }
      }, {
        title: this.$t("CATEGORY_ATTRIBUTES"),
        width: 50,
        align: "center",
        render: (h, params) => {
          if (params.row.category) {
            return h("Icon", {
              props: {
                type: "ios-paper",
                size: 28
              },
              class: "text-delta-blue",
              on: {
                click: () => {
                  if (params.row.category === "METAL") {
                    this.$showMetalCategoryAttribute(this, params.row.formNo);
                  } else if (params.row.category === "PLASTIC") {
                    this.$showPlasticCategoryAttribute(this, params.row.formNo);
                  } else if (params.row.category === "PWB") {
                    this.$showPwbCategoryAttribute(this, params.row.formNo);
                  }
                }
              }
            });
          }
          return h("span", {}, "");
        }
      }, {
        title: this.$t("ITEM_CATEGORY"),
        width: 100,
        align: "center",
        key: "itemCategory"
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("VALID_FROM"),
            h("br"),
            this.$t("VALID_TO")
          ]);
        },
        width: 140,
        align: "center",
        render: (h, params) => {
          if (!this.quotationList[params.index].validFrom) {
            this.quotationList[params.index].validFrom = moment().format("YYYY-MM-DD");
          }
          if (!this.quotationList[params.index].validTo) {
            this.quotationList[params.index].validTo = this.defaultValidTo;
          }
          return h("div", [
            h("DatePicker", {
              props: {
                value: this.quotationList[params.index].validFrom,
                type: "date",
                format: "yyyy-MM-dd",
                placeholder: "Select Date",
                transfer: true
              },
              on: {
                "on-change": (val) => {
                  this.quotationList[params.index].validFrom = val;
                }
              }
            }),
            h("DatePicker", {
              props: {
                value: this.quotationList[params.index].validTo,
                type: "date",
                format: "yyyy-MM-dd",
                placeholder: "Select Date",
                transfer: true
              },
              on: {
                "on-change": (val) => {
                  this.quotationList[params.index].validTo = val;
                }
              }
            })
          ]);
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("APPROVE"),
            h("br"),
            this.$t("REFERENCE_FILE")
          ]);
        },
        width: 70,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "md-cloud-upload",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.quotationUuid = params.row.uuid;
                this.cpcToSupervisorAttachments = this.quotationList[params.index].cpcToSupervisorAttachments ? this.quotationList[params.index].cpcToSupervisorAttachments.filter(attachment => !attachment.deleted) : [];
                this.actionType = this.quotationList[params.index].action ? this.quotationList[params.index].action : "";
                this.cpcToSupervisorAttachmentsModel = true;
              }
            }
          });
        }
      }, {
        renderHeader: (h, params) => {
          return h("div", {}, [
            this.$t("REJECT"),
            h("br"),
            this.$t("REFERENCE_FILE")
          ]);
        },
        width: 70,
        align: "center",
        render: (h, params) => {
          return h("Icon", {
            props: {
              type: "md-cloud-upload",
              size: 28
            },
            class: "text-delta-blue",
            on: {
              click: () => {
                this.quotationUuid = params.row.uuid;
                this.cpcToVendorAttachments = this.quotationList[params.index].cpcToVendorAttachments ? this.quotationList[params.index].cpcToVendorAttachments.filter(attachment => !attachment.deleted) : [];
                this.cpcToVendorAttachmentsModel = true;
              }
            }
          });
        }
      }];
    },
    cpcToSupervisorAttachmentsExited() {
      return this.cpcToSupervisorAttachments.length > 0
    },
    cpcToVendorAttachmentsExited() {
      return this.cpcToVendorAttachments.length > 0
    },
    selectAllAble() {
      return this.getCpcStatusEnum()['statusViewEnum'] == "WAITING_BUYER" || this.getCpcStatusEnum()['statusViewEnum'] == "WAITING_SUPPLIER"
    },
    modalSize() {
      return this.getModalSize()
    },
    windowWidth() {
      return this.getWindowsWidth() - 50
    }
  }
}

function getDefaultValidTo() {
  let today = new Date();
  if ((today.getMonth() + 1) > 9) {
    return moment([today.getFullYear() + 1, 11, 31]).format("YYYY-MM-DD")
  } else {
    return moment([today.getFullYear(), 11, 31]).format("YYYY-MM-DD")
  }
}

function search(vueInstance) {
  vueInstance.selectAllType = ""
  let url = ""
  if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_FORM_NO") {
    vueInstance.serachDetailTpye = "Form. No"
    vueInstance.routerValue = vueInstance.getCpcFormNo()
    url = "/cpc/detail/" + vueInstance.getCpcQuotationId()
    getSearch(vueInstance, url)
  } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_GROUP_ID") {
    vueInstance.isGroupType = true
    vueInstance.serachDetailTpye = vueInstance.$t('GROUP_KEY')
    vueInstance.routerValue = vueInstance.getCpcGroupId()
    url = "/cpc/details/group/" + vueInstance.getCpcGroupUuid()
    getSearch(vueInstance, url)
  } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_PART_NO") {
    vueInstance.serachDetailTpye = vueInstance.$t("PART_NO")
    vueInstance.routerValue = vueInstance.getCpcDeltaPnSingle()
    url = "/cpc/details/"
    getCriteriaSearch(vueInstance, url)
  } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_VENDOR_NAME") {
    vueInstance.serachDetailTpye = vueInstance.$t("VENDOR")
    vueInstance.routerValue = vueInstance.getCpcOaCode()
    url = "/cpc/details/"
    getCriteriaSearch(vueInstance, url)
  }
}

function getSearch(vueInstance, url) {
  if (url == "" || vueInstance.routerValue == "") {
    vueInstance.Back()
  } else {
    vueInstance.toggleLoading(true)
    vueInstance.$quotationHttp
      .get(url)
      .then((response) => {
        vueInstance.quotationList = [];
        vueInstance.quotationList = response.data._embedded.cpcQuotationDetailResourceList;
        if (vueInstance.quotationList.length == 0) {
          vueInstance.$Notice.success({
            title: Translate("COMMON_MESSAGE_INFO"),
            desc: Translate("COMMON_MESSAGE_INFO"),
            render: h => {
              return h('span', [
                Translate("COMMON_TEXT_NOTHING")
              ])
            }
          });
        }
      })
      .catch(() => {
        vueInstance.Back()
      })
      .finally(() => {
        vueInstance.toggleLoading(false);
      });
  }
}

function getCriteriaSearch(vueInstance, url) {
  if (url == "" || vueInstance.routerValue == "") {
    vueInstance.Back()
  } else {
    let deltaPnArray = []
    vueInstance.getCpcDeltaPn().split(';').forEach(a => {
      deltaPnArray.push(a)
    })

    let vendorPnArray = []
    vueInstance.getCpcVendorPn().split(';').forEach(a => {
      vendorPnArray.push(a)
    })

    let vnCodeArray = []
    vueInstance.getCpcVendorCode().split(';').forEach(a => {
      vnCodeArray.push(a)
    })
    let queryData = {
      "rfqType": vueInstance.getCpcRfqType(),
      "status": vueInstance.getCpcStatusEnum()['statusViewEnum'],
      "deltaPartNos": vueInstance.getCpcDeltaPn() == "" ? [] : deltaPnArray,
      "vendorPartNos": vueInstance.getCpcVendorPn() == "" ? [] : vendorPnArray,
      "vendorCodes": vueInstance.getCpcVendorCode() == "" ? [] : vnCodeArray,
      "fromRfqDate": vueInstance.getCpcFromRfqDate() == "" ? null : moment(vueInstance.getCpcFromRfqDate()).format('YYYY-MM-DD'),
      "toRfqDate": vueInstance.getCpcToRfqDate() == "" ? null : moment(vueInstance.getCpcToRfqDate()).format('YYYY-MM-DD')
    }

    if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_PART_NO") {
      queryData['deltaPartNo'] = vueInstance.getCpcDeltaPnSingle()
    } else if (vueInstance.$route.name == "CPC_MAINTAIN_DETAIL_VENDOR_NAME") {
      queryData['oaCode'] = vueInstance.getCpcOaCode()
    }

    vueInstance.toggleLoading(true)
    vueInstance.$quotationHttp
      .post(url, JSON.stringify(queryData))
      .then((response) => {
        vueInstance.toggleLoading(false)
        vueInstance.quotationList = []
        vueInstance.quotationList = response.data._embedded.cpcQuotationDetailResourceList
        if (vueInstance.quotationList.length == 0) {
          vueInstance.$Notice.success({
            title: Translate("COMMON_MESSAGE_INFO"),
            desc: Translate("COMMON_MESSAGE_INFO"),
            render: h => {
              return h('span', [
                Translate("COMMON_TEXT_NOTHING")
              ])
            }
          });
        }
      })
      .catch(() => {
        vueInstance.$router.push({ name: 'CPC_MAINTAIN' })
        vueInstance.toggleLoading(false)
      })
  }
}

function approveGroup(groupRequestData, vueInstance) {
  return vueInstance.$quotationHttp
    .post("/cpc/group/approve", JSON.stringify(groupRequestData))
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

function approve(cpcRequestData, vueInstance) {
  return vueInstance.$quotationHttp
    .post("/cpc/approve", JSON.stringify(cpcRequestData))
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}


function deleteQuotation(cpcRequestData, vueInstance) {
  return vueInstance.$quotationHttp
    .post("/cpc/delete", JSON.stringify(cpcRequestData))
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      vueInstance.toggleLoading(false)
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

function reject(cpcRequestData, vueInstance) {
  return vueInstance.$quotationHttp
    .post("/cpc/reject", JSON.stringify(cpcRequestData))
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

function unGroup(quotation, vueInstance) {
  return vueInstance.$quotationHttp
    .put("/cpc/ungroup/" + vueInstance.routerValue + "/" + quotation.id + "/" + quotation.formNo)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

function highPriceCheck(cpcRequestData, vueInstance) {
  return vueInstance.$quotationHttp
    .post("/quotation/highPriceCheck", JSON.stringify(cpcRequestData))
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      if (error.response.status == 444) {
        let text = vueInstance.$buildErrorMessage(error)
        vueInstance.$Swal.fire({
          icon: "error",
          title: Translate("COMMON_MESSAGE_ERROR"),
          text,
        })
      }
    })
}

function buildCpcRequestData(quotation) {
  return {
    "uuid": quotation.uuid,
    "formNo": quotation.formNo,
    "price": quotation.price,
    "currency": quotation.currency,
    "targetPrice": quotation.targetPrice,
    "rawMaterialPrice": quotation.rawMaterialPrice,
    "rawMaterialType": quotation.rawMaterialType,
    "comments": quotation.comments,
    "remark": quotation.remark,
    "validFrom": quotation.validFrom,
    "validTo": quotation.validTo,
    "cpcToSupervisorAttachments": quotation.cpcToSupervisorAttachments,
    "cpcToVendorAttachments": quotation.cpcToVendorAttachments,
    "cpcHighPriceInfoRecordDto": quotation.cpcHighPriceInfoRecordDto,
    "itemCategory": quotation.itemCategory
  }
}

function validation(quotationsList, vueInstance) {
  let errorMessage = ""
  quotationsList.forEach(quotation => {
    if (quotation.action == "Approve" || quotation.action == "Rejected" || quotation.action == "Cancel") {
      if (!quotation.comments) {
        errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('PLEASE_KEY_IN') + vueInstance.$t('COMMENTS') + " <br>"
      }
    }
  })
  if (errorMessage) {
    vueInstance.toggleLoading(false)
    AlertInfo(vueInstance, errorMessage).then(() => {
    })
  }
  return errorMessage == ""
}

function checkRequired(cpcRequestDataList, vueInstance) {
  let errorMessage = ""
  cpcRequestDataList.forEach(quotation => {
    if (quotation.infoRecordFlag) {
      if (!quotation.materialType) {
        errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('MATERIAL_TYPE') + vueInstance.$t('IS_REQUIRED') + " <br>"
      }
      if (!quotation.transportDays) {
        errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('TRANSPORT_DAYS') + vueInstance.$t('IS_REQUIRED') + " <br>"
      }
      if (!quotation.planDeliveryTime) {
        errorMessage = errorMessage + quotation.formNo + ": " + vueInstance.$t('PLAN_DELIVERY_TIME') + vueInstance.$t('IS_REQUIRED') + " <br>"
      }
    }
  })
  if (errorMessage) {
    vueInstance.toggleLoading(false)
    AlertInfo(vueInstance, errorMessage).then(() => {
    })
  }
  return errorMessage == "";
}
</script>

<style scoped>
/* table {
  width: 200% !important;
} */
</style>
